import httpClient from './httpClient'

const apiAdminPrice = val => httpClient.post('/inc/utilv2.php', val),
    apiGetPriceTiers = val => httpClient.post('/inc/utilv2.php', val),
    apiSaveTier = val => httpClient.post('/inc/utilv2.php', val),
    apiRemoveTier = val => httpClient.post('/inc/utilv2.php', val)

export { apiAdminPrice, apiGetPriceTiers, apiSaveTier, apiRemoveTier }
